import { colors, ThemeOptions, PaletteColorOptions } from '@material-ui/core';
import { ThemesModeEnum } from 'constants/themeEnum';
// import * as createPalette from '@material-ui/core/styles/createPalette';

// declare module '@mui/material/styles' {
//   interface Theme {
//     status: {
//       danger: React.CSSProperties['color'];
//     };
//   }

//   interface Palette {
//     neutral: Palette['primary'];
//   }
//   interface PaletteOptions {
//     neutral: PaletteOptions['primary'];
//   }

//   interface PaletteColor {
//     darker?: string;
//   }
//   interface SimplePaletteColorOptions {
//     darker?: string;
//   }
//   interface ThemeOptions {
//     status: {
//       danger: React.CSSProperties['color'];
//     };
//   }
// }

// declare module '@material-ui/core/styles/createPalette' {
//   // add new colors
//   interface PaletteOptions {
//     topnav?: PaletteColorOptions;
//   }
// }

interface IThemesConfig {
  [ThemesModeEnum.Dark]?: ThemeOptions;
  [ThemesModeEnum.Light]?: ThemeOptions;
}

interface IPalletesConfig {
  [key: string]: IThemesConfig;
}

export enum PalletesEnum {
  DefaultPallete = 'DefaultPallete',
  Pallete1 = 'Pallete1',
  Pallete2 = 'Pallete2',
}

export const Palletes: IPalletesConfig = {
  [PalletesEnum.DefaultPallete]: {
    [ThemesModeEnum.Dark]: {
      palette: {
        primary: {
          main: colors.common.black,
        },
        type: 'dark',
      },
    },
    [ThemesModeEnum.Light]: {
      palette: {
        primary: {
          main: '#9816d9',
          contrastText: colors.common.white,
        },
        secondary: {
          main: '#4808c7',
        },
        topnav: {
          main: colors.common.white,
          contrastText: colors.common.black['500'],
        },
        type: 'light',
      },
    },
  },
  [PalletesEnum.Pallete1]: {
    [ThemesModeEnum.Dark]: {
      palette: {
        primary: {
          main: colors.common.black,
        },
        type: 'dark',
      },
    },
    [ThemesModeEnum.Light]: {
      palette: {
        type: 'light',
        primary: {
          main: '#0032A5',
        },
        secondary: {
          main: '#0047E9',
        },
        topnav: {
          // main: '#E3E5E5',
          main: colors.common.white,
          // contrastText: '#fff',
        },
      },
    },
  },
  [PalletesEnum.Pallete2]: {
    [ThemesModeEnum.Dark]: {
      palette: {
        primary: {
          main: colors.common['black'],
        },
        secondary: {
          main: colors.grey['700'],
        },
        background: {
          // default: '#121212',
          default: '#121212',
        },
        text: {
          // primary: 'white',
        },
        type: 'dark',
      },
    },
    [ThemesModeEnum.Light]: {
      palette: {
        type: 'light',
        primary: {
          main: '#0032A5',
          contrastText: colors.common.white,
        },
        secondary: {
          main: '#0047E9',
        },
        topnav: {
          main: colors.common.white,
          contrastText: colors.common.black['500'],
        },
      },
    },
  },
};
